'use client';

import { c as _c } from "react/compiler-runtime";
import { ToastProvider } from '@7f-ui/components/toast/toast-provider';
import { MediaStateProvider } from '@7f-ui/hooks/use-media-state';
import { ImageProvider } from '@7f-ui/image-provider';
import { registerTrackingEventTransformer } from '@data-access/lib/execute';
import { enrichExperienceReviewItems } from '@feat/feat-tracking/reviews';
import { UrlStateProvider } from '@feat/feat-url-state/provider';
import { useConsentSettings } from '@utils/utils-analytics/use-consent-settings';
import { JotaiProvider } from '@utils/utils-jotai/src/jotai-provider';
import { LazyMotion } from 'motion/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import type { ReactNode } from 'react';
import type { AppSessionUser } from 'src/lib/auth/client/app-session.types';
import { AppSessionProvider } from 'src/lib/auth/client/app-session-provider';
import { AppAuthToastQueryHandler } from './(auth)/_components/app-auth-toast-query-handler';
import { AppApiProvider } from './app-api-provider';
const loadFeatures = () => import('motion/react').then(res => res.domAnimation);
if (typeof window !== 'undefined') {
  registerTrackingEventTransformer(enrichExperienceReviewItems);
}
export function Providers(t0) {
  const $ = _c(6);
  const {
    children,
    initialSession
  } = t0;
  useConsentSettings();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppAuthToastQueryHandler />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <JotaiProvider><MediaStateProvider><UrlStateProvider><ToastProvider>{t1}<ImageProvider>{children}</ImageProvider></ToastProvider></UrlStateProvider></MediaStateProvider></JotaiProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== initialSession || $[4] !== t2) {
    t3 = <NuqsAdapter><LazyMotion strict={true} features={loadFeatures}><AppApiProvider><AppSessionProvider initialUser={initialSession}>{t2}</AppSessionProvider></AppApiProvider></LazyMotion></NuqsAdapter>;
    $[3] = initialSession;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}